export type ExpensesMethodChangeModalContext = {
  currentMethod: string;
  filingId: string;
  orgId: string;
  onSuccess: () => void; // Redirect to filings page
};

let currentContext: ExpensesMethodChangeModalContext | null = null;

export const EXPENSES_METHOD_CHANGE_MODAL_OPEN_EVENT = 'expensesMethodChangeModal:open';
export const EXPENSES_METHOD_CHANGE_MODAL_CLOSE_EVENT = 'expensesMethodChangeModal:close';

export function setExpensesMethodChangeModalContext(ctx: ExpensesMethodChangeModalContext) {
  currentContext = ctx;
}

export function getExpensesMethodChangeModalContext() {
  return currentContext;
}

export function openExpensesMethodChangeModal() {
  document.dispatchEvent(new CustomEvent(EXPENSES_METHOD_CHANGE_MODAL_OPEN_EVENT));
}

export function closeExpensesMethodChangeModal() {
  document.dispatchEvent(new CustomEvent(EXPENSES_METHOD_CHANGE_MODAL_CLOSE_EVENT));
}

